import { render } from "./PopUpEditCourse.vue?vue&type=template&id=eec38bf4"
import script from "./PopUpEditCourse.vue?vue&type=script&lang=js"
export * from "./PopUpEditCourse.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__